/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export const inputCriteriaAutocompleteMultiSelectionConfiguration: {
    autocompleteDebounceTime: number;
    paginationConfiguration: {
        firstResult: number;
        maxResults: number;
    };
} = {
    autocompleteDebounceTime: 300,
    paginationConfiguration: {
        firstResult: 0,
        maxResults: 10
    }
};
